/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import Toggle from 'material/toggle/toggle';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/callouts/callout/callout_styles';



/* ========== ~~~~~~~~~~ CALLOUT : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Callout extends Component {
	constructor(props) {
		super(props);
		this.state = { phase: 'loading' };
		this.timeout = null;
    }
    componentDidMount() {
        this.timeout = setTimeout(() => {
            this.setState({ phase: 'loaded' });
        }, 10);
    }
    componentWillUnmount() {
	    clearTimeout(this.timeout);
    }
	render() {
        const location = this.props.location === 'in-content' ? 'incontent' : 'rail';
		return (
	        <div className={`callout ${location} ${this.props.classes.callout} ${this.props.type} ${this.state.phase} ${this.props.on}`}>
	        	<div className={`headline`}>
                    <div className={`group`}>
                        <div className={`title`}>{this.props.title}</div>
                    </div>
                    <div className={`group`}>
                        <Toggle handleClick={this.props.handleToggle} value={this.props.type} on={this.props.on} type={'switch'} variant={'secondary'} />
                    </div>
                </div>
                <div className={`bodyarea`}>
                    {this.props.children}
                </div>
	        </div>
		);
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Callout);